export { useWordRowStatsLabels } from "#use-word-row-stats-labels";
